import React, { useState, useEffect } from 'react';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import { TextField, Button, Box, Typography, Grid, Paper } from '@mui/material';
import axios from 'axios';
import { hosturl } from 'constants/constant';
import { useNavigate } from 'react-router-dom';

export default function Settings() {
  // State to hold form data
  const [formData, setFormData] = useState({
    amount: '', // New field for amount
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [appointmentAmounts, setAppointmentAmounts] = useState([]); // State for stored appointment amounts
  const [editingId, setEditingId] = useState(null); // Track which amount is being edited
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch data on component mount
    axios.get(`${hosturl}/appointmentAmount`)
      .then((response) => {
        setAppointmentAmounts(response.data);
        setLoading(false);
      })
      .catch((err) => {
        setError("Failed to load data.");
        setLoading(false);
      });
  }, []);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSave = () => {
    const newAmount = { amount: formData.amount };

    if (editingId) {
      // If there's an editingId, send a PUT request to update the existing amount
      axios.put(`${hosturl}/appointmentAmount/${editingId}`, newAmount)
        .then((response) => {
          setAppointmentAmounts(appointmentAmounts.map(amount =>
            amount._id === editingId ? response.data : amount
          ));
          setFormData({ amount: '' });
          setEditingId(null); // Reset editing mode
        })
        .catch((err) => setError('Error updating amount'));
    } else {
      // Otherwise, it's a new amount
      axios.post(`${hosturl}/appointmentAmount`, newAmount)
        .then((response) => {
          setAppointmentAmounts([...appointmentAmounts, response.data]);
          setFormData({ amount: '' });
        })
        .catch((err) => setError('Error saving amount'));
    }
  };

  const handleDelete = (id) => {
    axios.delete(`${hosturl}/appointmentAmount/${id}`)
      .then(() => {
        setAppointmentAmounts(appointmentAmounts.filter((amount) => amount._id !== id));
      })
      .catch((err) => setError('Error deleting amount'));
  };

  const handleEdit = (id, amount) => {
    setFormData({ ...formData, amount: amount });
    setEditingId(id); // Set the ID of the item being edited
  };

  // Display loading message or error if fetching fails
  if (loading) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <Box component="main" sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}>
          <Typography variant="h5" gutterBottom>Loading...</Typography>
        </Box>
      </DashboardLayout>
    );
  }

  if (error) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <Box component="main" sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}>
          <Typography variant="h4" gutterBottom color="error">{error}</Typography>
        </Box>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box component="main" sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}>
        <Typography variant="h5" gutterBottom>{editingId ? 'Edit' : 'Add'} Appointment Amount</Typography>
        <TextField
          label="Amount"
          variant="outlined"
          name="amount"
          value={formData.amount}
          onChange={handleInputChange}
          fullWidth
          sx={{ mb: 2 }}
        />
        {editingId && (
          <Button variant="contained" style={{backgroundColor:'orange', color:"black"}} onClick={handleSave}>
            Update Amount
          </Button>
        )}

        <Grid container spacing={2} sx={{ mt: 3 }}>
          {appointmentAmounts.map((amount) => (
            <Grid item xs={12} sm={6} md={4} key={amount._id}>
              <Paper sx={{ p: 2 }}>
                <Typography variant="h6">Amount: {amount.amount}</Typography>
                <Button
                  // variant="outlined"
                  style={{backgroundColor:'skyblue', color:'black'}}
                  onClick={() => handleEdit(amount._id, amount.amount)}
                  sx={{ mr: 1 }}
                >
                  Edit
                </Button>
                {/* <Button
                style={{color:"black", backgroundColor:'red'}}
                  onClick={() => handleDelete(amount._id)}
                >
                  Delete
                </Button> */}
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    </DashboardLayout>
  );
}
